import * as React from 'react';
import {InfoBanner} from "@ferry/portal-core";

export class AccountDetailsBanner extends React.Component<{}> {

    public render(): React.ReactNode {
        return <InfoBanner wording={<><span className="font-weight-bold">Heads up</span> – changing your account details could also change your price</>} />
    }
}
